import { pick } from 'lodash-es';

import { YesNoInProgress } from '@pflegia/types/common/enums/yes-no-in-progress.enum';

export enum NursingApprenticeshipExperience {
  OneTwoYears = 'one_two_years',
  ThreeYears = 'three_years',
  BasicNursing = 'basic_nursing',
  Caregiver = 'caregiver',
  NoApprenticeship = 'no_apprenticeship',
  SearchingApprenticeship = 'searching_apprenticeship',
  InRecognition = 'in_recognition',
  AcquiredAbroad = 'acquired_abroad',
  // Multiposting only values
  Yes = 'yes',
  InProgress = 'in_progress',
}

export enum EmployerNursingApprenticeshipExperience {
  BasicNursing = 'basic_nursing',
  OneYear = 'one_year',
  TwoYears = 'two_years',
  Experience = 'experience',
  ExperienceWillingToLearn = 'experience_willing_to_learn',
  NoQualificationRequired = 'no_qualification_required',
  OneYearTrainingWithLg = 'one_year_training_with_lg',
  OneYearTrainingOrLg = 'one_year_training_or_lg',
  OneYearTrainingStrict = 'one_year_training_strict',
}
const NURSING_APPRENTICESHIP_EXPERIENCE: (keyof typeof NursingApprenticeshipExperience)[] = [
  'OneTwoYears',
  'BasicNursing',
  'NoApprenticeship',
  'SearchingApprenticeship',
  'AcquiredAbroad',
];

export const getNursingApprenticeshipExperienceAnswersEditPage = (isPraxia: boolean) => {
  const allKeys = Object.keys(NursingApprenticeshipExperience) as (keyof typeof NursingApprenticeshipExperience)[];
  const keysToInclude = allKeys.filter(key => {
    if (key === 'Yes') return false;
    if (isPraxia && (key === 'BasicNursing' || key === 'Caregiver')) return false;
    return true;
  });
  return pick(NursingApprenticeshipExperience, keysToInclude);
};

export const NursingApprenticeshipExperienceAnswers = pick(NursingApprenticeshipExperience, NURSING_APPRENTICESHIP_EXPERIENCE);

export const QUALIFICATION_TO_NURSING_APPRENTICESHIP_EXPERIENCE: Record<YesNoInProgress, NursingApprenticeshipExperience> = {
  [YesNoInProgress.Yes]: NursingApprenticeshipExperience.Yes,
  [YesNoInProgress.No]: NursingApprenticeshipExperience.NoApprenticeship,
  [YesNoInProgress.InProgress]: NursingApprenticeshipExperience.InProgress,
};

export const TRANSLATED_NURSING_APPRENTICESHIP_EXPERIENCE = {
  [NursingApprenticeshipExperience.BasicNursing]: 'Pflegebasiskurs',
  [NursingApprenticeshipExperience.NoApprenticeship]: 'Ich habe keine Ausbildung',
  [NursingApprenticeshipExperience.OneTwoYears]: '1-2 jährige Ausbildung',
  [NursingApprenticeshipExperience.ThreeYears]: '3 jährige Ausbildung',
  [NursingApprenticeshipExperience.SearchingApprenticeship]: 'Ich suche eine Ausbildung',
  [NursingApprenticeshipExperience.Yes]: 'Pflegebasiskurs oder 1-2 jährige Ausbildung',
  [NursingApprenticeshipExperience.InProgress]: 'Noch in der Ausbildung',
  [NursingApprenticeshipExperience.Caregiver]: 'Betreuungskraft',
  [NursingApprenticeshipExperience.InRecognition]: 'Im Prozess der Anerkennung',
  [NursingApprenticeshipExperience.AcquiredAbroad]: 'Im Ausland erworben',
};

export const SPECIAL_TRANSLATED_NURSING_APPRENTICESHIP_EXPERIENCE_FOR_TEMPLATES = {
  [NursingApprenticeshipExperience.NoApprenticeship]: 'Keine Ausbildung',
  [NursingApprenticeshipExperience.SearchingApprenticeship]: 'Auf der Suche nach einer Ausbildung',
};
